import { createApp, h } from 'vue';
import { createPinia } from 'pinia';
import { configure } from 'vee-validate';
import PrimeVue from 'primevue/config';
import AntVue from 'ant-design-vue';
import { Amplify } from 'aws-amplify';
import { initRum } from '@/services/monitoring';
import '@/assets/styles/index.css';

// @ts-ignore
import App from '@/App.vue';
import router from '@/router';
import aura from '@/assets/styles';
import configService from '@/services/configService'; // Adjust the path as necessary
import { ApplicationConfiguration } from '@/types';
import aplosApi from './services/aplosApi';
import { useMessageStore } from './store/messages';
import { Loader2 } from 'lucide-vue-next';
import { useColorMode } from '@vueuse/core';

const pinia = createPinia();

async function initApp() {


  const LoadingComponent = {
    setup() {
      let mode = useColorMode();
      return () =>
        h('div', { class: 'flex flex-col items-center justify-center min-h-screen' }, [
          h('img', {
            src:
              mode.value === 'dark'
                ? 'https://cdn.aplos-nca.com/assets/MonoLogoWhite.svg'
                : 'https://cdn.aplos-nca.com/assets/ColorLogo.svg',
            class: 'mb-4 h-14',
            alt: 'Loading Logo',
          }),
          h(Loader2, { class: 'animate-spin', size: 48 }),

        ]);
    },
  };

  const loaderApp = createApp(LoadingComponent);
  loaderApp.mount(`#loader`);


  // Load configuration and initialize services
  await configService.loadApplicationConfig();
  const { data } = await aplosApi.getPublicOutMessages();
  const appConfig: ApplicationConfiguration | null = configService.getApplicationConfigData();
  const AwsConfig = appConfig?.idp;
  if (AwsConfig) {
    // console.debug('AWS Config', AwsConfig);
    Amplify.configure(AwsConfig);
  } else {
    console.error('Config is not available.');
  }


  // Initialize the main app
  const app = createApp(App);

  // Global error handler
  app.config.errorHandler = (err, instance, info) => {
    console.error('Global error captured in initApp:', err, info, instance);
    // For example, you might trigger a reload:
    // window.location.reload();

    // Or show a user-friendly notification
    // notifyUser('An unexpected error occurred. Please refresh the page.');
  };

  initRum(appConfig);

  app.use(router);
  app.use(pinia);
  app.use(PrimeVue, {
    unstyled: true,
    pt: aura
  });
  app.use(AntVue);
  const { messages } = useMessageStore();
  messages.logOutMessages = data.messages;

  // Unmount the loading app and remove its container
  loaderApp.unmount();

  // mount the main app
  app.mount('#app');


  configure({
    validateOnBlur: true,
    validateOnChange: false,
    validateOnInput: false,
    validateOnModelUpdate: false,
  });
}

initApp();
